import React, { useContext, useEffect, useState, useRef } from 'react';
import { ProductContext } from '../../context/ProductContext.js';
import { FavoriteContext } from '../../context/FavoriteContext.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as SolidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as RegularHeart } from '@fortawesome/free-regular-svg-icons';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
// Swiper modules
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, FreeMode, Mousewheel } from 'swiper/modules';
// Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/free-mode';
import "./CampaignProduct.css";
import { useImage } from "../../context/ImageContext.js";
import Loader from '../Loader.js';

const CampaignProducts = () => {
    const { getImageUrl } = useImage();
    const { favorites, addToFavorite, removeFavorite } = useContext(FavoriteContext);
    const { state, fetchProducts, dispatch, fetchCampaignProduct } = useContext(ProductContext);
    const { products, campaignProduct, loading, error } = state;
    const [currentPage, setCurrentPage] = useState(1);
    const [isFetching, setIsFetching] = useState(false);
    const swiperRef = useRef(null);

    const handleProductClick = (sef) => {
        window.location.href = `/urun/${sef}`;
    };

    const handlePrevSlide = () => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slidePrev();
        }
    };

    const handleNextSlide = () => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slideNext();
        }
    };


    useEffect(() => {

        fetchCampaignProduct();

    }, []);
    const isFavorite = (product) => {
        return favorites.some(favProduct =>
            String(favProduct.urun_id) === String(product.id)
        );
    };

    const handleFavoriteToggle = async (event, product) => {
        event.stopPropagation();
        event.preventDefault();

        try {
            if (isFavorite(product)) {
                const favoriteProduct = favorites.find(fav =>
                    String(fav.urun_id) === String(product.id)
                );
                if (favoriteProduct) {
                    await removeFavorite(favoriteProduct);
                }
            } else {
                await addToFavorite(product);
            }
        } catch (error) {
            console.error('Favori işlemi sırasında hata:', error);
        }
    };


    useEffect(() => {
        const loadProducts = async () => {
            if (isFetching) return;
            setIsFetching(true);
            await fetchProducts(currentPage);
            setIsFetching(false);
        };
        loadProducts();
    }, [currentPage]);

    useEffect(() => {
        dispatch({ type: 'RESET_PRODUCTS' });
        setCurrentPage(1);
    }, []);


    useEffect(() => {
        const handleScroll = () => {
            const scrollThreshold = window.innerWidth < 768 ? 1300 : 700;
            if (
                window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - scrollThreshold &&
                !isFetching &&
                !loading
            ) {
                setCurrentPage(prev => prev + 1);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [isFetching, loading]);

    // Swiper breakpoints configuration
    const swiperBreakpoints = {
        320: {
            slidesPerView: 3.5,
            spaceBetween: 15,
        },
        480: {
            slidesPerView: 3.5,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 3.5,
            spaceBetween: 25,
        },
        1024: {
            slidesPerView: 4.8,
            spaceBetween: 30,
        },
        1200: {
            slidesPerView: 6.2,
            spaceBetween: 35,
        },
        1400: {
            slidesPerView: 7.5,
            spaceBetween: 40,
        },
    };
    if (loading) return <Loader />;
    if (error) return <div>Hata: {error}</div>;


    return (
        <>

            <div className="campaign-container p-3 text-center rounded-3 shadow mb-md-5 mb-4">
                <div className='campaign-title d-flex flex-md-row flex-column justify-content-between align-items-center text-md-start text-center mb-2'>
                    <h4 className='text-white m-0'>Son 1 Adet Fırsatları</h4>
                    <h5 className='text-white m-o'><a className='text-decoration-none d-flex align-items-center' href='/kampanyali-urunler/all'>Tüm Ürünler <FontAwesomeIcon icon={faChevronRight} style={{ marginLeft: '5px' }} /></a></h5>
                </div>
                <div className="campaign-swiper-container overflow-hidden">
                    <Swiper
                        modules={[Navigation, Pagination, Autoplay, FreeMode, Mousewheel]}
                        spaceBetween={20}
                        slidesPerView="auto"
                        loop={campaignProduct.length >= 8}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                            waitForTransition: false,
                            stopOnLastSlide: false,
                        }}
                        freeMode={{
                            enabled: false,
                        }}
                        mousewheel={{
                            forceToAxis: true,
                            sensitivity: 0.5,
                        }}
                        navigation={{
                            nextEl: '.campaign-swiper-button-next',
                            prevEl: '.campaign-swiper-button-prev',
                        }}
                        grabCursor={true}
                        touchRatio={1.5}
                        touchAngle={45}
                        simulateTouch={true}
                        allowTouchMove={true}
                        resistanceRatio={0.85}
                        threshold={5}
                        longSwipesRatio={0.5}
                        longSwipesMs={300}
                        followFinger={true}
                        shortSwipes={true}
                        longSwipes={true}
                        breakpoints={swiperBreakpoints}
                        className="campaign-products-swiper"
                        watchSlidesProgress={true}
                        preventInteractionOnTransition={false}
                        observer={true}
                        observeParents={true}
                        updateOnWindowResize={true}
                        ref={swiperRef}
                    >
                        {campaignProduct.map((product) => (
                            <SwiperSlide key={product.id}>
                                <a
                                    href={`/urun/${product.sef}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="campaign-product-card-link"
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                >
                                    <div className="campaign-product-card text-start rounded-3 overflow-hidden me-2">
                                        <div className="campaign-product-image-wrapper">
                                            <img
                                                className='w-100'
                                                src={getImageUrl(product.image.i1)}
                                                alt={product.baslik}
                                                loading="lazy"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = '/no-image.png';
                                                }}
                                            />
                                            {product.eski_fiyat !== product.fiyat && (
                                                <div className="discount-badge">
                                                    <div className='d-flex flex-column'>
                                                        {(((product.eski_fiyat - product.fiyat) / product.eski_fiyat) * 100).toFixed(1)}%
                                                        <span>İndirim</span>
                                                    </div>
                                                </div>
                                            )}
                                            
                                            <FontAwesomeIcon
                                                icon={isFavorite(product) ? SolidHeart : RegularHeart}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    handleFavoriteToggle(e, product)
                                                }}
                                                className="favorite-icon position-absolute fs-6 d-block circle p-2 opacity-75"
                                                style={{ color: isFavorite(product) ? 'red' : 'gray', fontSize: window.innerWidth <= 768 ? '16px' : '24px' }}
                                            />
                                        </div>
                                        <div className="campaign-product-info px-2">
                                            <h4 className="campaign-responsive-name mt-2 mb-0 fw-bold">{product.baslik}</h4>
                                            {/* Görüntülenme Metni */}
                                            <div className='d-flex align-items-center gap-2 wiev-count' style={{ marginTop: '4px' }}>
                                                <i className="fas fa-eye"></i>
                                                <span>
                                                    {(product.view_count ?? 0).toLocaleString('tr-TR')} incelenme
                                                </span>
                                            </div>
                                            <div className="ratings fs-6 py-1">
                                                {'★'.repeat(5)}
                                            </div>
                                            <div className="price mb-2">
                                                {product.fiyat ? (
                                                    <div className="d-flex gap-sm-1 gap-0">
                                                        <span className="old-price text-decoration-line-through fw-bold">{product.eski_fiyat.toLocaleString('tr-TR')} TL</span>
                                                        <span className="discounted-price text-danger fw-bold">{product.fiyat.toLocaleString('tr-TR')} TL</span>
                                                    </div>
                                                ) : (
                                                    <span className="original-price">{product.fiyat.toLocaleString('tr-TR')} TL</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    {/* Custom Navigation Buttons */}
                    <div className="campaign-swiper-button-prev campaign-swiper-button" onClick={handlePrevSlide}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                        </svg>
                    </div>
                    <div className="campaign-swiper-button-next campaign-swiper-button" onClick={handleNextSlide}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" />
                        </svg>
                    </div>
                </div>

            </div>


        </>
    );
};

export default CampaignProducts;